import axios from "axios";
import { useAuthStore } from "../store";
import toast from "react-hot-toast";

//export const domain = `https://revenue.phototime.works/api/v1`
 export const domain = `https://revenuebe.phototime.click/api/v1`

const api = axios.create({
  // baseURL: `http://localhost:8085/api/v1`,
  // baseURL: `http://171.244.142.243:8085/api/v1`,
  // baseURL: `https://testbackend.phototime.click/api/v1`,
  baseURL: `https://revenuebe.phototime.click/api/v1`,
 // baseURL: `https://revenue.phototime.works/api/v1`,
});

api.interceptors.request.use(
  function (config) {
    // const test = useAuthStore?.getState().token;
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token.trim()}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const setupAxiosInterceptors = (navigate?: any) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {

    }
  );
};

export default api;
